// The head bootstrap and footer bundle share one lifecycle.
function loaderState() {
  return (window.bone_duck_loader_state ||= { started: false, finished: false, timer: null });
}
export function initLoader() {
  const state = loaderState();
  if (state.started || state.finished) return;
  if (document.readyState === 'complete') {
    state.finished = true;
    return;
  }
  state.started = true;
  // Arm recovery before making the overlay visible, even before the body element exists.
  state.timer = window.setTimeout(hideLoaderOnLoad, 5000);
  document.documentElement.classList.add('loading-active');
  document.body?.classList.add('loading-active');
  window.addEventListener('load', hideLoaderOnLoad, { once: true });
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) hideLoaderOnLoad();
  });
}
export function hideLoaderOnLoad() {
  const state = loaderState();
  window.clearTimeout(state.timer);
  document.documentElement.classList.remove('loading-active');
  document.body?.classList.remove('loading-active');
  if (state.finished) return;
  state.finished = true;
  const spinner = document.getElementById('loading');
  if (!spinner) return;
  spinner.classList.remove('is-loading');
  spinner.classList.add('loaded');
  const remove = () => spinner.remove();
  spinner.addEventListener('transitionend', (event) => {
    if (event.target === spinner) remove();
  });
  // Reduced motion or a missing transition must not leave a stale overlay.
  window.setTimeout(remove, 600);
}
